import { userConstants } from "../constants/userConstants";
import { userService } from "../../services/API/userService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import auth from "../../services/auth";

export const userActions = {
  login,
  logout
};

function login(email, password, login_as) {
  return dispatch => {
    dispatch(request({ email }));
    userService.login(email, password, login_as).then(
      user => {
        dispatch(success(user));
      },

      error => {
        dispatch(failure(error.toString()));
        dispatch({
          type: userConstants.MESSAGE_POST_DONE,
          messages: error.toString()
        });
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  return dispatch => {

    userService.logout().then(
      user => {
        dispatch(success(user));
        history.push("/");
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function success(user) {
    return { type: userConstants.LOGOUT_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGOUT_FAILURE, error };
  }
}

function getUser() {
  return {
    type: actionTypes.USER_GET
  };
}

function getUserRequest() {
  return dispatch => {
    dispatch(request());

    userService
      .getUser()
      .then(
        user => dispatch(success(user)),
        error => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: userConstants.GET_USER_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GET_USER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.GET_USER_FAILURE, error };
  }
}

function register(user) {
  return dispatch => {
    dispatch(request(user));

    userService.register(user).then(
      user => {
        dispatch(success());
        history.push("/login");
        dispatch(alertActions.success("Registration successful"));
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function getAll() {
  return dispatch => {
    dispatch(request());

    userService
      .getAll()
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    userService
      .delete(id)
      .then(
        user => dispatch(success(id)),
        error => dispatch(failure(id, error.toString()))
      );
  };

  function request(id) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/user.js